(() => {
  function toneFor(value) {
    const v = String(value || '').toLowerCase();
    if (/rose/.test(v)) return '#c99b8c';
    if (/white|silver|platinum/.test(v)) return '#d8d9d6';
    if (/yellow|gold/.test(v)) return '#d5b55f';
    return '#d8d5cf';
  }

  function applyToneCorrection() {
    document.querySelectorAll('.it-jewellery-pdp .it-final-metal-options input[type="radio"]').forEach(input => {
      const fieldset = input.closest('fieldset');
      const label = fieldset?.querySelector(`label[for="${window.CSS?.escape ? CSS.escape(input.id) : input.id}"]`);
      const tone = label?.querySelector('.it-metal-tone');
      const copy = label?.querySelector('.it-final-metal-copy');
      if (tone) tone.style.setProperty('--it-metal-tone', toneFor(copy?.textContent || input.value));
    });
  }

  function schedule() { setTimeout(applyToneCorrection, 160); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule, { once: true });
  else schedule();
  document.addEventListener('change', event => {
    if (event.target?.closest?.('.it-jewellery-pdp')) schedule();
  }, true);
  document.addEventListener('shopify:section:load', schedule);
})();
